import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { NotificationPropsInterface } from './NotificationTypes';
import * as Styled from './NotificationStyles';

function Notification({ isShow, total }: NotificationPropsInterface) {
  if (!isShow) {
    return null;
  }

  return (
    <Styled.Wrapper slot="notification">
      <FuelTypography
        data-testid="notification-number"
        tag="p"
        size="caption"
        color="inherit"
        weight="bold"
      >
        {total}
      </FuelTypography>
    </Styled.Wrapper>
  );
}

export default Notification;
